import React from 'react';
import { Box } from '@mui/material';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import DotsAndCirlcesProfile from './profile/DotsAndCirlcesProfile';

export interface ContentfulAnimatedImage {
  alt: string;
  gatsbyImageData?: IGatsbyImageData;
  id: string;
  internal?: Record<string, string>;
  url?: string;
}

interface HeroAnimationProps {
  image?: ContentfulAnimatedImage;
}

const HeroAnimation = ({ image }: HeroAnimationProps) => {
  if (!image) {
    return null;
  }

  return (
    <Box sx={{
      height: '100%',
      left: 0,
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: 20,
    }}
    >
      {image.gatsbyImageData && (
        <Box
          className="hero-blob-animation"
          sx={{
            backgroundColor: '#000',
            position: 'absolute',
            right: '-2%',
            top: '50%',
            transform: 'translateY(-50%)',
            '&:after': {
              backgroundColor: 'transparent',
              backgroundImage: `url(${image.url})`,
            },
          }}
        />
      )}
      <DotsAndCirlcesProfile />
    </Box>
  );
};

export default HeroAnimation;
